import { useTranslation } from 'react-i18next'
import type { Discipline } from '@structural-climbing/validation'
import { Sheet } from '../../design/Sheet'
import { StandingsBoard, StandingsFilters } from './StandingsBoard'

interface Props {
  isOpen: boolean
  onClose: () => void
  gymId: string
  gymSlug: string
  discipline: Discipline
}

/** The leaderboard, slid up over the wall it ranks. */
export function StandingsSheet({ isOpen, onClose, gymId, gymSlug, discipline }: Props) {
  const { t } = useTranslation()

  return (
    <Sheet
      isOpen={isOpen}
      onClose={onClose}
      aria-label={t('standings.pageTitle')}
      data-testid="standings-sheet"
    >
      <div className="flex min-h-0 flex-col gap-4 overflow-y-auto overscroll-contain px-4 pb-6 pt-1">
        <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
          <h2 className="text-xl font-bold tracking-tight">{t('standings.pageTitle')}</h2>
          <StandingsFilters />
        </div>
        <StandingsBoard gymId={gymId} gymSlug={gymSlug} discipline={discipline} />
      </div>
    </Sheet>
  )
}
